import React from "react";
import ReactSlider from "react-slider";

interface PaziaSliderProps {
  label?: string;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
}
export const PaziaSlider = ({ label, onChange, min, max, step }: PaziaSliderProps) => {
  return (
    <div className="flex flex-col items-center">
      {label && <div className="text-slate-600 dark:text-slate-400">{label}</div>}
      <ReactSlider
        className="w-full h-8 border-red-100"
        thumbClassName="aaa example-thumb"
        trackClassName="ccc bg-primary-500 h-1 relative bg-red rounded"
        min={min}
        max={max}
        step={step}
        onChange={onChange}
        renderThumb={(props, state) => (
          <div {...props} className="h-3 w-3 rounded-xl bg-primary-800 cursor-pointer"></div>
        )}
      />
    </div>
  );
};
